import { renderSlot as _renderSlot, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-a21009ea")

_pushScopeId("data-v-a21009ea")
const _hoisted_1 = { class: "cus-tag-container" }
const _hoisted_2 = /*#__PURE__*/_createVNode("span", { class: "el-icon-close" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _renderSlot(_ctx.$slots, "default"),
    _createVNode("span", {
      class: "cus-tag-close",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('remove')))
    }, [
      _hoisted_2
    ])
  ]))
})